import { RouteRecordRaw } from '@vue-router';
import { configureRoutesMeta } from '@core/utils/configureRoutesMeta';
import { routes as baseRoutes } from './base';
import { routes as ownersOffices } from './ownersOffices';
import { routes as gis } from './gis';
import { routes as settlementCenter } from './settlementCenter';
import { routes as debtorRelations } from './debtorRelations';
import { routes as electronicControlRoom } from './electronicControlRoom';
import { routes as interactiveAccess } from './interactiveAccess';
import { routes as mailingDispatcher } from './mailingDispatcher';
import { routes as siteCompany } from './siteCompany';
import { routes as oneC } from './oneC';
import { routes as chatBot } from './chatBot';
import { routes as meetings } from './meetings';
import { routes as access } from './access';
import { routes as reminders } from './reminders';
import { routes as requestsDispatcher } from './requestsDispatcher';
import { routes as balance } from './balance';
// import DefaultLayout from '~/layouts/DefaultLayout.vue';
import { getCurrentBase } from "~/helpers/persistenceBase";

const routes: Array<RouteRecordRaw> = [
  {
    path: 'dashboard',
    name: 'Home',
    component: () => import('~/views/Home.vue'),
    meta: {
      title: 'Дашборд'
    }
  },
  {
    path: 'no-access',
    name: 'HasNoAccess',
    component: () => import('~/views/HasNoAccess.vue'),
  },
  ...baseRoutes,
  ...ownersOffices,
  ...interactiveAccess,
  ...gis,
  //...settlementCenter,
  ...debtorRelations,
  ...electronicControlRoom,
  ...mailingDispatcher,
  ...siteCompany,
  ...oneC,
  ...chatBot,
  ...meetings,
  ...access,
  ...reminders,
  ...requestsDispatcher,
  ...balance,
  // TODO: Очень хотелось бы иметь такую структуру router, а не старую
  // {
  //   path: '/reports',
  //   name: 'Reports',
  //   component: DefaultLayout,
  //   children: [
  //     {
  //       path: 'test',
  //       name: 'Reports.Test',
  //       component: () => import('~/views/reports/TestReportView.vue'),
  //     }
  //   ]
  // }
  // {
  //   path: '/reports/test',
  //   name: 'Reports.Test',
  //   component: () => import('~/views/reports/TestReportView.vue'),
  //   meta: {
  //     title: 'Тестовый отчет'
  //   }
  // }
];

const processedRoutes = configureRoutesMeta(routes, false, 'DefaultLayout');

export const authorizedRoutes = [
  {
    path: '/',
    redirect: () => {
      const base = getCurrentBase();
      return `/${base}/dashboard/`;
    },
  },
  {
    path: '/select-base',
    name: 'SelectBase',
    component: () => import('~/views/SelectBase.vue'),
    meta: {
      title: 'Выбор базы',
      layout: 'AuthLayout'
    }
  },
  {
  path: '/:base',
  component: () => import('~/views/BaseWrapperRoute.vue'),
  children: processedRoutes
}];

// export const authorizedRoutes = configureRoutesMeta(routes, false, 'DefaultLayout');

// const processedRoutes = routes.map((item) => {
//   const hasTrailingSlash = item.path.endsWith('/');
//   const baseSegment = hasTrailingSlash ? ':base?' : '/:base?';
//   return {
//     ...item,
//     path: `${item.path}${baseSegment}`
//   }
// });

// export const authorizedRoutes = configureRoutesMeta(processedRoutes, false, 'DefaultLayout');